export default __webpack_public_path__ + "static/media/app-store.52c1157d.png";